import { render } from "./list-category.vue?vue&type=template&id=7d2096a3&scoped=true"
import script from "./list-category.vue?vue&type=script&lang=js"
export * from "./list-category.vue?vue&type=script&lang=js"

import "./list-category.vue?vue&type=style&index=0&id=7d2096a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2096a3"]])

export default __exports__